// @flow
import { Dropdown } from 'semantic-ui-react'
import * as React from 'react'

type Props = {
  currentText: string,
  currentValue: string | number,
  options: Array<{ text: string, value: string }>,
  changeHandler: string => void
}

export function DesktopDropdown ({
  currentValue,
  options,
  changeHandler,
  currentText
}: Props) {
  return (
    <Dropdown
      scrolling
      selection
      value={currentValue}
      onChange={(e, { value }) => changeHandler(value)}
      options={options}
      text={currentText}
    />
  )
}

export function MobileDropdown ({
  currentValue,
  options,
  changeHandler,
  currentText
}: Props) {
  return (
    <select
      onChange={e => changeHandler(e.currentTarget.value)}
      value={currentValue}
    >
      {options.map(option => (
        <option value={option.value}>{option.text}</option>
      ))}
    </select>
  )
}



// WEBPACK FOOTER //
// ./src/components/selector/dropdownComponents.js